/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";
import { useRouter } from "next/router";
import ScholarshipCard from "@modules/study/common/scholarship_card";
import styles from "./uni_overview_scholarship.module.scss";

export const UniOverviewScholarship = ({ universityProfileData }) => {
  const router = useRouter();
  const { query } = router;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/university-scholarship/list/${universityProfileData?.universitySlug}?limit=4`
        );
        setLoading(false);
        setData(res.data.results);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, []);

  return (
    <Fragment>
      {data?.length == 0 ? (
        <></>
      ) : (
        <section>
          <div className="container">
            <div className={styles.title_wrapper}>
              <h2>Popular scholarships</h2>
              <p className={styles.short_description}>
                Planning to apply for scholarships to study at{" "}
                {universityProfileData?.universityName}?<br /> Get started on
                the process by exploring the{" "}
                <strong>international student scholarship</strong> options
                below!
              </p>
            </div>

            <Grid container spacing={3} justifyContent="center">
              {data?.map((item, i) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                  <ScholarshipCard
                    countryCurrencySymbol={
                      universityProfileData?.universityData
                        ?.countryCurrencySymbol
                    }
                    name={item?.scholarshipName}
                    amount={item?.scholarshipAmount}
                    deadline={item?.deadline}
                    link={`/study/${query.country_name}/university/${query.university_name}/scholarships/${item?.slug}`}
                    badge={item.badge ?? []}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default UniOverviewScholarship;
